
import Vue from 'vue'
const format = Vue.directive('format', {
	bind(el, v) {
	    var hours = parseInt(v.value / 60 / 60);
	    var minutes = parseInt(v.value / 60 - hours * 60);
	    var seconds = parseInt(v.value - minutes * 60 - hours * 60 * 60);
	    if (hours > 0) {
	      	el.innerHTML = (hours >= 9 ? hours : '0' + hours) + ":" + (minutes >= 9 ? minutes : '0' + minutes) + ":" + (seconds >= 9 ? seconds : '0' + seconds);
	    } else {
	      	el.innerHTML = (minutes >= 9 ? minutes : '0' + minutes) + ":" + (seconds >= 9 ? seconds : '0' + seconds);
	    }
	}
});
const short = Vue.directive('short', {
	bind(el, v) {
	    var str = String(v.value),
	      	length = str.length;
	    if (length >= 5 && length < 6) {
	      	el.innerHTML = str.substring(0, 1) + "万";
	    } else if (length >= 6 && length < 7) {
	      	el.innerHTML = str.substring(0, 2) + "万";
	    } else if (length >= 7 && length < 8) {
	      	el.innerHTML = str.substring(0, 3) + "万";
	    } else if (length >= 8 && length < 9) {
	      	el.innerHTML = str.substring(0, 1) + "千万";
	    } else if (length >= 9) {
	      	el.innerHTML = str.substring(0, 1) + "亿";
	    } else if (length < 5) {
	      	el.innerHTML = str;
	    }
  	}
});
export {format,short}



// WEBPACK FOOTER //
// ./src/components/comnFun.js